const {
  GET_ALL_NUMERISATION_REQUEST,
  GET_ALL_NUMERISATION_SUCCESS,
  GET_ALL_NUMERISATION_FAIL,
  ADD_NUMERISATION_REQUEST,
  ADD_NUMERISATION_SUCCESS,
  ADD_NUMERISATION_FAIL,
  UPDATE_NUMERISATION_REQUEST,
  UPDATE_NUMERISATION_SUCCESS,
  UPDATE_NUMERISATION_FAIL,
  DELETE_NUMERISATION_REQUEST,
  DELETE_NUMERISATION_SUCCESS,
  DELETE_NUMERISATION_FAIL
} = require("../../actionTypes/Paramaetrage/Numerisation");

function getAllNumerisations(state = { data: {} }, action) {
  switch (action.type) {
    case GET_ALL_NUMERISATION_REQUEST:
      return { loading: true, data: {} };
    case GET_ALL_NUMERISATION_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_ALL_NUMERISATION_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addNumerisation(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_NUMERISATION_REQUEST:
      return { loading: true, data: {} };
    case ADD_NUMERISATION_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_NUMERISATION_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateNumerisation(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_NUMERISATION_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_NUMERISATION_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_NUMERISATION_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteNumerisation(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_NUMERISATION_REQUEST:
      return { loading: true, data: {} };
    case DELETE_NUMERISATION_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_NUMERISATION_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

export {
  addNumerisation,
  updateNumerisation,
  deleteNumerisation,
  getAllNumerisations
};
